import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function SignIn() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const next = location.state?.from || "/dashboard";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await login(email, password);
      navigate(next);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const onGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main className="max-w-md mx-auto px-6 py-16">
      <p className="label-overline text-center">Return to the hermitage</p>
      <h1 className="font-display text-5xl text-center mt-3 mb-2">Sign in</h1>
      <div className="fleuron mb-8">❦</div>

      <form onSubmit={onSubmit} className="parchment-card space-y-5" data-testid="signin-form">
        <div>
          <label className="label-overline block mb-2">Email</label>
          <input data-testid="signin-email" className="field" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div>
          <label className="label-overline block mb-2">Password</label>
          <input data-testid="signin-password" className="field" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <p data-testid="signin-error" className="text-wax-red text-sm font-body italic">{error}</p>}
        <button data-testid="signin-submit" disabled={submitting} className="wax-button w-full">
          {submitting ? "Knocking…" : "Enter"}
        </button>

        <div className="flex items-center gap-3 my-2">
          <div className="flex-1 editorial-rule" />
          <span className="label-overline">or</span>
          <div className="flex-1 editorial-rule" />
        </div>

        <button type="button" onClick={onGoogle} data-testid="signin-google" className="ghost-button w-full">
          Continue with Google
        </button>
      </form>

      <p className="text-center mt-6 font-body text-ink-iron">
        New here?{" "}
        <Link to="/sign-up" data-testid="signin-to-signup" className="text-wax-red hover:underline italic">Take the vow</Link>
        {" · "}
        <Link to="/forgot-password" data-testid="signin-forgot" className="text-ink-marginalia hover:text-wax-red italic">Forgot password?</Link>
      </p>
    </main>
  );
}
